/**
 * Constants for the ShipmentTimelineWithThreadLines component.
 * Visual defaults for lane colors, message backgrounds, and sizing.
 */

/**
 * Default lane colors for thread visualization.
 * Readable, distinguishable colors for up to 6 threads.
 */
export const DEFAULT_LANE_COLORS = [
  "#FF6B6B", // Coral Red
  "#4ECDC4", // Teal
  "#45B7D1", // Sky Blue
  "#96CEB4", // Sage Green
  "#DDA0DD", // Plum
  "#F7DC6F", // Soft Yellow
];

/** Color for the "other threads" lane (non-top-N threads) */
export const DEFAULT_OTHER_THREADS_LANE_COLOR = "#9E9E9E";

/** Message bubble background for own domain messages */
export const DEFAULT_OWN_DOMAIN_BG = "#F5F5F5";

/** Message bubble background for other domain messages */
export const DEFAULT_OTHER_DOMAIN_BG = "#F5F5F5";
